import React from 'react'
import Topbar from './tobBar'
import { Outlet } from 'react-router-dom'

function Layout() {
  return (
    <div>
        <Topbar/>
        <Outlet/>
    </div>
  )
}

export default Layout